export function oaText(type) {
  if (type == "HYBRID_OA") {
    return "其他OA";
  }
  if (type == "GREEN_OA") {
    return "绿色OA";
  }
  if (type == "BRONZE_OA") {
    return "青铜OA";
  }
  if (type == "GOLD_OA" || type == "DIAMOND_OA") {
    return "黄金OA";
  }
  // if (type == "DIAMOND_OA") {
  //   return "钻石OA";
  // }
  if (
    type == "UNKNOWN_OA" ||
    type == "NOT_OA" ||
    type == "PART_OA" ||
    type == "OA"
  ) {
    return;
  }
}

export function oaColor(type) {
  if (type == "HYBRID_OA") {
    return "QITA";
  }
  if (type == "GREEN_OA") {
    return "GREEN";
  }
  if (type == "BRONZE_OA") {
    return "BRONZE";
  }
  if (type == "GOLD_OA" || type == "DIAMOND_OA") {
    return "GOLD";
  }
  if (
    type == "UNKNOWN_OA" ||
    type == "NOT_OA" ||
    type == "PART_OA" ||
    type == "OA"
  ) {
    return;
  }
}

export function newColor(type) {
  if (type == "10") {
    return "NEWS";
  }
  if (type == "20") {
    return "GREEN";
  }
  if (type == "30") {
    return "BRONZE";
  }
  if (type == "40") {
    return "GOLD";
  }
  if (type == "50") {
    return "DIAMOND";
  }
  if (type == "60") {
    return "PINK";
  }
  if (type == "70") {
    return "YELLOW";
  }
  if (type == "80") {
    return "QITA";
  }
  if (type == "90") {
    return "DIAMOND";
  }
}
